import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { get_my_tasks, update_task_status } from './api';

const initialState = {
  loading: true,
  user: null
};

const actions = {
  GET_MY_TASKS: 'plans/GET_MY_TASKS',
  UPDATE_MY_TASK_STATUS: 'plans/UPDATE_MY_TASK_STATUS'
};

export const getMyTasks = createAsyncThunk(
  actions.GET_MY_TASKS,
  async (payload) => {
    const response = await get_my_tasks('my_tasks', payload);

    return response;
  }
);

export const updateTaskStatus = createAsyncThunk(
  actions.UPDATE_MY_TASK_STATUS,
  async (payload) => {
    const response = await update_task_status('update_plan_status', payload);

    return response;
  }
);

export const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMyTasks.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyTasks.fulfilled, (state, action) => {
        state.loading = false;

        const { success, message: msg } = action.payload;
        if (!success) {
          message.error(msg);
        }
      })
      .addCase(getMyTasks.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(updateTaskStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTaskStatus.fulfilled, (state, action) => {
        state.loading = false;

        const { status, message: msg } = action.payload;
        if (status === 200) {
          message.success(msg);
        }
      })
      .addCase(updateTaskStatus.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  }
});

export const selectPlansSlice = (state) => {
  return state.plans;
};

export default plansSlice.reducer;
